import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    // Energy devices
    voltageOptimiser: false,
    iBoost: false,
    smartThermostat: false,
    boilerManager: false,

    // EV Charger
    evCharger: null,
    evBatterySize: 0,

    // Groundwork
    softGround: 0,
    hardGround: 0,

    // Delivery
    deliveryMiles: 100
}

const addonsSlice = createSlice({
    name: 'addons',
    initialState,
    reducers: {
        setVoltageOptimiser: (state, action) => {
            state.voltageOptimiser = action.payload
        },
        setIBoost: (state, action) => {
            state.iBoost = action.payload
        },
        setSmartThermostat: (state, action) => {
            state.smartThermostat = action.payload
        },
        setBoilerManager: (state, action) => {
            state.boilerManager = action.payload
        },
        setEVCharger: (state, action) => {
            state.evCharger = action.payload
        },
        setEVBatterySize: (state, action) => {
            state.evBatterySize = action.payload
        },
        setSoftGround: (state, action) => {
            state.softGround = action.payload
        },
        setHardGround: (state, action) => {
            state.hardGround = action.payload
        },
        setDeliveryMiles: (state, action) => {
            state.deliveryMiles = action.payload
        },

        // Bulk update from quote data
        updateAddonsFromQuote: (state, action) => {
            const data = action.payload
            if (data.voltageOptimiser !== undefined) state.voltageOptimiser = data.voltageOptimiser
            if (data.vo !== undefined) state.voltageOptimiser = data.vo
            if (data.iBoost !== undefined) state.iBoost = data.iBoost
            if (data.iboost !== undefined) state.iBoost = data.iboost
            if (data.smartThermostat !== undefined) state.smartThermostat = data.smartThermostat
            if (data.smartthermostat !== undefined) state.smartThermostat = data.smartthermostat
            if (data.boilerManager !== undefined) state.boilerManager = data.boilerManager
            if (data.boilermanager !== undefined) state.boilerManager = data.boilermanager
            if (data.evCharger !== undefined) state.evCharger = data.evCharger
            if (data.evcharger !== undefined) state.evCharger = data.evcharger
            if (data.evBatterySize !== undefined) state.evBatterySize = data.evBatterySize
            if (data.evbatterysize !== undefined) state.evBatterySize = data.evbatterysize
            if (data.softGround !== undefined) state.softGround = data.softGround
            if (data.hardGround !== undefined) state.hardGround = data.hardGround
            if (data.deliveryMiles !== undefined) state.deliveryMiles = data.deliveryMiles
            if (data.delivery_miles !== undefined) state.deliveryMiles = data.delivery_miles
        },

        resetAddons: () => initialState
    }
})

export const {
    setVoltageOptimiser,
    setIBoost,
    setSmartThermostat,
    setBoilerManager,
    setEVCharger,
    setEVBatterySize,
    setSoftGround,
    setHardGround,
    setDeliveryMiles,
    updateAddonsFromQuote,
    resetAddons
} = addonsSlice.actions

// Selectors
export const selectVoltageOptimiser = (state) => state.addons.voltageOptimiser
export const selectIBoost = (state) => state.addons.iBoost
export const selectSmartThermostat = (state) => state.addons.smartThermostat
export const selectBoilerManager = (state) => state.addons.boilerManager
export const selectEVCharger = (state) => state.addons.evCharger
export const selectEVBatterySize = (state) => state.addons.evBatterySize
export const selectSoftGround = (state) => state.addons.softGround
export const selectHardGround = (state) => state.addons.hardGround
export const selectDeliveryMiles = (state) => state.addons.deliveryMiles

// Computed selectors
export const selectTotalGroundwork = (state) =>
    state.addons.softGround + state.addons.hardGround

export const selectHasEnergyAddons = (state) =>
    state.addons.iBoost ||
    state.addons.smartThermostat ||
    state.addons.boilerManager

export default addonsSlice.reducer
